<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1120_6746)">
      <path
        d="M35.7734 20.25C36.0546 22.2008 36.238 24.8693 35.3639 25.8907C33.9171 27.5794 24.7574 27.5794 24.7574 24.2021C24.7574 22.5011 26.2637 21.3851 24.817 19.6954C23.3939 18.0338 20.8435 18.0068 18.0062 18.0068C15.169 18.0068 12.6186 18.0338 11.1955 19.6954C9.74873 21.384 11.2562 22.5 11.2562 24.2021C11.2562 27.5805 2.09535 27.5805 0.648604 25.8907C-0.225521 24.8693 -0.0432709 22.2008 0.239104 20.25C0.456229 18.9484 1.00298 17.5433 2.7546 15.75C5.3826 13.2986 9.35835 11.2939 17.8656 11.2511V11.25H18.1469V11.2511C26.6541 11.2939 30.6299 13.2986 33.2579 15.75C35.0095 17.5433 35.5562 18.9472 35.7734 20.25Z"
        fill="#FDFFFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_1120_6746">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
  },
};
</script>

<style lang="scss" scoped></style>
